/**
 * This is a utility function to help with exhaustive switch case checking feature of typescript.
 * http://www.typescriptlang.org/docs/handbook/advanced-types.html
 * Refer to the exhaustive checking section
 */
export const assertUnreachableHelper = (errorMessage) => (_) => {
    throw new Error(errorMessage);
};
//# sourceMappingURL=assertion-utils.js.map